
import {
  defineComponent, onBeforeMount, reactive, watch,
} from 'vue';
import Icone from '@/core/components/Icone.vue';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import SelecionarDataInicialFinal from '@/core/components/Tela/SelecionarDataInicialFinal.vue';
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import { IFiltrosRelatorioVendas } from '@/models/Relatorios/Venda/IFiltrosRelatorioVendas';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import { IDadosRelatorioVendaCliente, IDadosRelatorioVendaClienteItem } from '@/models/Relatorios/Venda/IDadosRelatorioVendaCliente';
import { IPagination } from '@/core/models/AntDesign/IPagination';
import { IListaPaginadaMetaData } from '@/core/models/Consulta/IListaPaginada';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import { ISalvamentoAutomatico } from '@/models/Entidades/MeuSistema/ISalvamentoAutomatico';
import { useGradeBase } from '@/core/composables/GradeBase';
import storeSistema from '@/store/storeSistema';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import ServicoRelatoriosVendas from '@/servicos/Relatorios/ServicoRelatoriosVendas';
import { EStatusRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import UtilitarioDispositivo from '@/core/utilitarios/UtilitarioDispositivo';
import Card from '@/core/components/Tela/Card.vue';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import { ETipoRelatorioVenda } from '@/models/Enumeradores/Relatorios/ETipoRelatorioVenda';
import SelecionarTipoRelatorioVendas from '@/components/Relatorios/Vendas/SelecionarTipoRelatorioVendas.vue';
import SelecionarCliente from '@/components/Cadastros/Pessoas/Clientes/SelecionarCliente.vue';
import SelecionarColaborador from '@/components/Cadastros/Pessoas/Colaboradores/SelecionarColaborador.vue';
import SelecionarFormaPagamento from '@/components/Cadastros/Financeiro/SelecionarFormaPagamento.vue';

export default defineComponent({
  name: 'RelatorioVendaCliente',
  components: {
    TituloPadrao,
    Icone,
    Card,
    SelecionarTipoRelatorioVendas,
    SelecionarDataInicialFinal,
    SelecionarCliente,
    SelecionarColaborador,
    SelecionarFormaPagamento,
    PreviewPdf,
  },
  setup(props) {
    const servicoSistema = new ServicoSistema();
    const servicoRelatorioVenda = new ServicoRelatoriosVendas();
    const {
      telaBase, filtrarPermissaoDadosUsuarioMultiEmpresas, apresentarMensagemErro, apresentarMensagemAlerta,
      preencherEmpresasDisponiveis, verificaConceitoParaApresentarEmpresas, defineEmpresasSelecionadasComPermissao,
      preencherDadosRota,
    } = useTelaBase();
    const { gradeBase } = useGradeBase();
    const state = reactive({
      dataInicial: '01/01/2001',
      dataFinal: '10/01/2001',
      filtros: {} as IFiltrosRelatorioVendas,
      filtrosUtilizados: {} as IFiltrosRelatorioVendas,
      resultado: {} as IDadosRelatorioVendaCliente,
      itens: [] as IDadosRelatorioVendaClienteItem[],
      paginacao: {} as IPagination,
      paginacaoAPI: { totalRegistros: 0, paginaAtual: 1 } as IListaPaginadaMetaData,
      timerRegistros: 0,
      totalRegistrosComMascara: '100',
      arquivoPdf: [] as IArquivoPdf[],
      mostrarFiltrosInteligentes: 1,
      mostrarFiltros: 0,
      mostrarItens: false,
      cacheAutomatico: {} as ISalvamentoAutomatico,
    });
    telaBase.apresentarEmpresas = false;

    function preencherColunas() {
      if (storeSistema.state.layoutMobile) {
        gradeBase.colunas = [
          {
            title: 'Código', dataIndex: 'CodigoCliente', key: 'Item', position: 1, visible: false,
          },
          {
            title: 'Nome Cliente', dataIndex: 'NomeCliente', key: 'NomeCliente', position: 2, visible: true,
          },
        ];
      } else if (state.filtros.tipo === ETipoRelatorioVenda.Simplificado) {
        gradeBase.colunas = [
          {
            title: 'Código', dataIndex: 'codigoCliente', key: 'codigo', position: 1, visible: false,
          },
          {
            title: 'Nome Cliente', dataIndex: 'nomeCliente', key: 'nome', position: 2, visible: true, align: 'left',
          },
          {
            title: 'CPF/CNPJ', dataIndex: 'identificador', key: 'identificador', position: 3, visible: true, align: 'left', customRenderRow: ECustomRenderRow.MascararCPFCNPJ,
          },
          {
            title: 'Data Última Venda', dataIndex: 'dataVendaFormatada', key: 'dataVenda', position: 4, visible: true, align: 'left',
          },
          {
            title: 'Total Vendas', dataIndex: 'qtdVendas', key: 'totalVendas', position: 5, visible: true, align: 'center',
          },
          {
            title: 'Valor Total Vendas', dataIndex: 'valorTotal', key: 'valorTotal', position: 6, visible: true, align: 'left', customRenderRow: ECustomRenderRow.MascararFracionado,
          },
        ];
      } else {
        gradeBase.colunas = [
          {
            title: 'Código', dataIndex: 'codigoCliente', key: 'codigo', position: 1, visible: false,
          },
          {
            title: 'Nome Cliente', dataIndex: 'nomeCliente', key: 'nome', position: 2, visible: true, align: 'left',
          },
          {
            title: 'Numero da Venda', dataIndex: 'numeroVenda', key: 'numero', position: 3, visible: true,
          },
          {
            title: 'Numero da NF', dataIndex: 'numeroNota', key: 'nota', position: 4, visible: true,
          },
          {
            title: 'Data Venda', dataIndex: 'dataVendaFormatada', key: 'dataVenda', position: 5, visible: true, align: 'left',
          },
          {
            title: 'Forma Pagamento', dataIndex: 'formaPagamento', key: 'formaPagamento', position: 6, visible: true, align: 'left',
          },
          {
            title: 'Vendedor', dataIndex: 'vendedor', key: 'vendedor', position: 7, visible: true, align: 'left',
          },
          {
            title: 'Valor Total', dataIndex: 'valorTotal', key: 'valorTotal', position: 8, visible: true, align: 'left', customRenderRow: ECustomRenderRow.MascararFracionado,
          },
        ];
      }
    }

    function obterIdentificadorCache(): string {
      return `RELATORIO_VENDA_CLIENTE_${storeSistema.getters.codigoUsuarioAutenticado()}`;
    }

    function salvarCache() {
      const identificador = obterIdentificadorCache();
      state.cacheAutomatico.data = UtilitarioData.obterDataAtual();
      state.cacheAutomatico.codigoEmpresa = state.filtros.empresa;
      state.cacheAutomatico.codigoUsuario = storeSistema.getters.codigoUsuarioAutenticado();
      state.cacheAutomatico.identificador = telaBase.identificadorRecurso;
      state.cacheAutomatico.dados = JSON.stringify(state.filtros);
      servicoSistema.salvamentoAutomaticoLocalStorage(`${identificador}`, state.cacheAutomatico);
    }

    async function recuperarCache() {
      const cacheRestaurado = await servicoSistema.obterSalvamentoAutomaticoLocalStorage(obterIdentificadorCache());
      if (UtilitarioGeral.valorValido(cacheRestaurado)) {
        const cache = JSON.parse(cacheRestaurado.dados);
        state.filtros = cache;
        state.dataInicial = cache.dataInicial;
        state.dataFinal = cache.dataFinal;
        state.mostrarFiltros = 1;
        state.mostrarFiltrosInteligentes = 0;
      }
    }

    async function buscarRelatorio() {
      telaBase.carregando = true;
      state.filtros.dataInicial = state.dataInicial;
      state.filtros.dataFinal = state.dataFinal;
      state.filtros.numeroPagina = state.paginacao.current;
      state.filtros.qtdRegistrosPagina = state.paginacao.pageSize;
      state.filtros.qtdTotalRegistros = state.paginacao.total;
      state.resultado = await servicoRelatorioVenda.obterVendaCliente(state.filtros);
      state.filtrosUtilizados = UtilitarioGeral.clonarObjeto(state.filtros);
      salvarCache();
      preencherColunas();
      state.mostrarItens = true;
      state.itens = state.resultado.itens.dados;
      state.paginacaoAPI = state.resultado.itens.metaData;
      state.mostrarFiltros = 0;
      state.mostrarFiltrosInteligentes = 0;
      telaBase.carregando = false;
    }

    async function alterarQuantidadeRegistroTotal(valor: any) {
      clearTimeout(state.timerRegistros);
      let totalRegistros = 100;
      state.timerRegistros = setTimeout(async () => {
        if (UtilitarioGeral.valorValido(valor)) {
          const limiteRegistros = UtilitarioMascara.removerMascaraNumero(valor);
          if (limiteRegistros > 0) {
            totalRegistros = limiteRegistros;
          }
        }
        state.paginacao.total = totalRegistros;
        state.totalRegistrosComMascara = UtilitarioMascara.mascararNumeroInteiro(totalRegistros);
        await buscarRelatorio();
      }, 600);
    }

    async function imprimir(tipoArquivoRelatorio:ETipoArquivo) {
      telaBase.carregando = true;
      if (!UtilitarioGeral.validaLista(state.itens)) {
        await buscarRelatorio();
      }
      const retornoRelatorio = await servicoRelatorioVenda.obterArquivoVendaCliente(tipoArquivoRelatorio, state.filtrosUtilizados);
      telaBase.carregando = false;
      if (retornoRelatorio.status === EStatusRetornoRequisicao.Sucesso) {
        if (tipoArquivoRelatorio === ETipoArquivo.PDF) {
          state.arquivoPdf = [{ nome: '', link: retornoRelatorio.link } as IArquivoPdf];
        } else {
          UtilitarioGeral.downloadArquivo(retornoRelatorio.link);
        }
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retornoRelatorio.mensagem);
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Erro) {
        apresentarMensagemErro(retornoRelatorio.mensagem);
      }
    }

    async function atualizarSelecaoEmpresas() {
      telaBase.empresasSelecionadas = [] as number[];
      telaBase.empresasSelecionadas.push(state.filtros.empresa);
      telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas(telaBase.empresasSelecionadas);
      await buscarRelatorio();
    }

    function usarFiltroInteligente(filtro: number) {
      switch (filtro) {
        case 2:
          state.dataInicial = UtilitarioData.obterPrimeiroDiaMesAtual();
          state.dataInicial = UtilitarioData.adicionarMesNaData(state.dataInicial, -3);
          state.dataFinal = UtilitarioData.obterUltimoDiaMesAtual();
          state.dataFinal = UtilitarioData.adicionarMesNaData(state.dataFinal, 0);
          state.filtros.tipo = ETipoRelatorioVenda.Simplificado;
          break;
        case 3:
          state.dataInicial = UtilitarioData.obterPrimeiroDiaMesAtual();
          state.dataInicial = UtilitarioData.adicionarMesNaData(state.dataInicial, 0);
          state.dataFinal = UtilitarioData.obterUltimoDiaMesAtual();
          state.dataFinal = UtilitarioData.adicionarMesNaData(state.dataFinal, 0);
          state.filtros.tipo = ETipoRelatorioVenda.Agrupado;
          break;
        case 4:
          state.dataInicial = UtilitarioData.obterPrimeiroDiaMesAtual();
          state.dataInicial = UtilitarioData.adicionarMesNaData(state.dataInicial, -3);
          state.dataFinal = UtilitarioData.obterUltimoDiaMesAtual();
          state.dataFinal = UtilitarioData.adicionarMesNaData(state.dataFinal, 0);
          state.filtros.tipo = ETipoRelatorioVenda.Agrupado;
          break;
        default:
          state.dataInicial = UtilitarioData.obterPrimeiroDiaMesAtual();
          state.dataInicial = UtilitarioData.adicionarMesNaData(state.dataInicial, 0);
          state.dataFinal = UtilitarioData.obterUltimoDiaMesAtual();
          state.dataFinal = UtilitarioData.adicionarMesNaData(state.dataFinal, 0);
          state.filtros.tipo = ETipoRelatorioVenda.Simplificado;
          break;
      }
      buscarRelatorio();
    }
    function limparFiltros() {
      state.filtros = {} as IFiltrosRelatorioVendas;
      state.filtros.empresa = storeSistema.getters.codigoEmpresaOperacao();
      state.filtros.tipo = ETipoRelatorioVenda.Simplificado;
      state.dataInicial = UtilitarioData.obterPrimeiroDiaMesAtual();
      state.dataFinal = UtilitarioData.obterUltimoDiaMesAtual();
    }

    async function onPageChange(current: number, pageSize: number) {
      state.paginacao.current = current;
      state.paginacao.pageSize = pageSize;
      await buscarRelatorio();
    }

    async function onShowSizeChange(current: number, pageSize: number) {
      state.paginacao.current = 1;
      state.paginacao.pageSize = pageSize;
      await buscarRelatorio();
    }

    watch(() => storeSistema.state.layoutMobile, () => {
      preencherColunas();
    });

    onBeforeMount(async () => {
      preencherDadosRota();
      await preencherEmpresasDisponiveis();
      await defineEmpresasSelecionadasComPermissao();
      verificaConceitoParaApresentarEmpresas();
      // recuperarCache();
      preencherColunas();
      limparFiltros();
      state.paginacao.total = 100;
      state.paginacao.showSizeChanger = true;
      state.paginacao.pageSize = 100;
      state.paginacao.current = 1;
      state.paginacao.pageSizeOptions = ['10', '50', '100', '500', '1000'];
    });

    return {
      state,
      props,
      window,
      ETipoArquivo,
      ECustomRenderRow,
      UtilitarioMascara,
      UtilitarioData,
      UtilitarioDispositivo,
      storeSistema,
      telaBase,
      gradeBase,
      preencherColunas,
      salvarCache,
      recuperarCache,
      buscarRelatorio,
      alterarQuantidadeRegistroTotal,
      imprimir,
      atualizarSelecaoEmpresas,
      usarFiltroInteligente,
      onPageChange,
      onShowSizeChange,
    };
  },
});
